const routes = [{
        path: '/home',
        component: () =>
            import ('layouts/MainLayout.vue'),
        children: [{
            path: '',
            name: 'home',
            component: () =>
                import ('src/pages/Index/Index.vue')
        }],
        meta: { requiresAuth: true, name: 'Home' }
    },
    {
        path: '/code', // This path needs to be accessible if a user is or is NOT logged into the system ... 
        component: () =>
            import ('src/pages/RegistrationCode/Index.vue')
    },
    {
        path: '/coaching-tracks',
        component: () =>
            import ('layouts/MainLayout.vue'),
        children: [{
            path: '',
            name: 'coaching-tracks',
            component: () =>
                import ('src/pages/CoachingTracks/Index.vue')
        }],
        meta: { requiresAuth: true, name: 'Home' }
    },
    {
        path: '/join-a-session',
        component: () =>
            import ('layouts/MainLayout.vue'),
        children: [{
            path: '',
            name: 'join-a-session',
            component: () =>
                import ('src/pages/Index_agora/Index.vue')
        }],
        meta: { requiresAuth: true, name: 'Coaching Session' }
    },
    {
        path: '/meeting/:id',
        component: () =>
            import ('layouts/MainLayout.vue'),
        children: [{
            path: '/',
            name: 'meeting',
            component: () =>
                import ('src/pages/Meeting/Meeting.vue')
        }],
        meta: { requiresAuth: true, name: 'Meeting' }
    },
    {
        path: '/dial-in',
        component: () =>
            import ('layouts/GuestLayout.vue'),
        children: [{
            path: '/',
            name: 'DialIn',
            component: () =>
                import ('src/pages/Meeting/_components/TurboBridge.vue')
        }],
        meta: { requiresAuth: true, name: 'DialIn' }
    },
    {
        path: '/profile',
        component: () =>
            import ('layouts/MainLayout.vue'),
        children: [{
            path: '/',
            name: 'profile',
            component: () =>
                import ('src/pages/Profile/Profile.vue')
        }],
        meta: { requiresAuth: true, name: 'Profile' }
    },
    {
        path: '/',
        component: () =>
            import ('layouts/GuestLayout.vue'),
        children: [{
            path: '',
            name: 'LoginOrRegister',
            component: () =>
                import ('pages/LoginOrRegister.vue')
        }]
    },
    {
        path: '/callback',
        name: 'callback',
        component: () =>
            import ('layouts/GuestLayout.vue'),
        children: [{
            path: '',
            component: () =>
                import ('pages/Auth0Callback.vue')
        }]
    },
    {
        path: '/logout',
        component: () =>
            import ('layouts/GuestLayout.vue'),
        children: [{
            path: '',
            component: () =>
                import ('pages/Auth0Logout.vue')
        }]
    },
    {
        path: '/register',
        component: () =>
            import ('layouts/GuestLayout.vue'),
        children: [{
            path: '',
            component: () =>
                import ('src/pages/Register/Register.vue')
        }]
    },
    {
        path: '/set-password',
        component: () =>
            import ('layouts/GuestLayout.vue'),
        children: [{
            path: '',
            component: () =>
                import ('src/pages/SetPassword.vue')
        }]
    },
    {
      path: '/community',
      component: () =>
        import ('layouts/MainLayout.vue'),
      children: [{
        path: '',
        name: 'community',
        component: () => import('src/pages/Groups/Index.vue'),
      }],
      meta: { requiresAuth: true, name: 'Home' }
    },
    {
        path: '/groups',
        component: () =>
            import ('layouts/MainLayout.vue'),
        children: [{
            path: '',
            name: 'groups',
            redirect: '/community'
        }],
        meta: { requiresAuth: true, name: 'Home' }
    },
    {
        path: '/dashboard',
        component: () =>
            import ('layouts/MainLayout.vue'),
        children: [{
            path: '',
            name: 'dashboard',
            component: () =>
                import ('src/pages/Dashboard/Index.vue')
        }],
        meta: { requiresAuth: true, name: 'Dashboard' }
    },
    {
        path: '/reports',
        component: () =>
            import ('layouts/MainLayout.vue'),
        children: [{
            path: '',
            component: () =>
                import ('src/pages/Dashboard/Report.vue')
        }],
        meta: { requiresAuth: true, name: 'Reports' }
    },
    {
        path: '/coach',
        component: () =>
            import ('layouts/CoachLayout.vue'),
        children: [{
            path: '/',
            name: 'upcoming coaching sessions',
            component: () =>
                import ('src/pages/Coach/UpcomingSessions/Index.vue')
        },
        {
            path: 'coaching-tracks',
            name: 'Coaching Tracks',
            component: () =>
                import ('src/pages/Coach/CoachingTracks/Index.vue')
        },
        {
            path: 'di-sessions',
            name: 'Drop-In Sessions',
            component: () =>
                import ('src/pages/Coach/DropInSessions/Index.vue')
        },
        {
            path: 'overall-dashboard',
            name: 'Overall Dashboard',
            component: () =>
                import ('src/pages/Coach/Dashboard/Index.vue')
        },
        {
            path: 'coaching-track-dashboard',
            name: 'Coaching Tracks Dashboard',
            component: () =>
            import ('src/pages/Coach/CtDashboard/Index.vue'),
        },
        {
            path: 'drop-in-sessions',
            name: 'Drop-In Sessions Dashboard',
            component: () =>
                import ('src/pages/Coach/DsDashboard/Index.vue')
        },
        {
            path: 'coaching-engagement',
            name: '1:1 Coaching Engagements',
            component: () =>
                import ('src/pages/Coach/CoachingEngagement/Index.vue')
        },
        {
            path: 'impact-survey-result/:id',
            name: 'impact-survey-result',
            component: () =>
                import ('src/pages/Coach/CtDashboard/impactSurveyResults.vue')
        }
        ],
        meta: { requiresAuth: true }
    },

    // Always leave this as last one,
    // but you can also remove it
    {
        path: '*',
        component: () =>
            import ('pages/Error404.vue')
    }
]

export default routes
